import { render, staticRenderFns } from "./DeploymentSelector.vue?vue&type=template&id=1a122394&scoped=true&"
import script from "./DeploymentSelector.vue?vue&type=script&lang=js&"
export * from "./DeploymentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a122394",
  null
  
)

export default component.exports